import { dataHooks } from '../../../libs/dataHooks';

export const templatesPageDataHooks = dataHooks<{
  cbdBanner: {};
  numericPagination: {};
  templates: {};
  subHeader: {};
  networkErrorModal: {};
}>('templatesPage');
